export default {"src":"/_next/static/media/frame-placeholder.be6cabdb.svg","height":472,"width":1008,"blurWidth":0,"blurHeight":0};